import { render } from "./EditAddPusatData.vue?vue&type=template&id=35a519c4"
import script from "./EditAddPusatData.vue?vue&type=script&lang=js"
export * from "./EditAddPusatData.vue?vue&type=script&lang=js"

import "./EditAddPusatData.vue?vue&type=style&index=0&id=35a519c4&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__